<template>
	<div>
		<!-- 二级导航栏 -->
		<!-- <nav-bar :list="nva_list" v-model="nva_index" title="会议终端解决方案"></nav-bar> -->

		<!-- 头部图片 -->
		<div class="po-r" @mouseenter="stop" @mouseout="play">
			<div class="po-r" style="height: 9.47rem;">
				<div class="banner-item" :style="`background-image: url(${v.img});`" :class="{ 'current-banner': i == banner_index }" v-for="(v, i) in banner_list" :key="i">
					<!-- 内容 -->
					<div class="banner-content content" :class="{ 'current-banner-content': i == banner_index }" v-show="i == banner_index">
						<div class="banner-title " :class="is_phone ?'fs-30':'fs-52'">{{v.title}}</div>
						<div class=" co-w mt-64 mb-70"  :class="is_phone ?'fs-14':'fs-18'">{{v.info || ''}}</div>
						<a :href="v.url" target="_blank">
							<readMore></readMore>
						</a>
					</div>
				</div>
			</div>

			<!-- 轮播图的指示点 -->
			<div class="point-box content">
				<!-- 遍历点 -->
				<div class="banner-point" v-for="(v, i) in banner_list" :key="i" :style="i == banner_list.length - 1 ? '' : 'margin-right: 0.2rem;'" @click="banner_index = i">
					<div :style="banner_index == i ? 'transition: all 5.2s;width: calc(100% - 2px);':''" class="move-point"></div>
				</div>
			</div>

			<!-- 下滑按钮 -->
			<div class="slid-down-box" @click="nextPage">
				<div class="slid-down"></div>
				<div class="">{{$store.state.language == 'EN' ? 'slide':'滑动'}}</div>
			</div>
		</div>

		<!-- 产品中心 -->
		<products id="nav0"></products>

		<!-- 解决方案 -->
		<solution id="nav1"></solution>

		<!-- 新闻资讯 -->
		<news id="nav2"></news>

		<!-- 客户合作 -->
		<logo id="nav3"></logo>
	</div>
</template>

<script>
import products from '@/components/homePage/products.vue';
import solution from '@/components/homePage/solution.vue';
import news from '@/components/homePage/news.vue';
import logo from '@/components/homePage/logo.vue';
import readMore from '../components/readMore.vue';
export default {
	components: {
		products,
		solution,
		news,
		logo,
		readMore
	},
	name: 'HomePage',
	data() {
		return {
			nva_list: ['产品中心', '解决方案', '新闻资讯', '合作客户'],
			nva_index: 0,
			banner_list: [
				'https://imgtest.togy.com.cn/oyjj/langGuo/home_bg.png',
				'https://imgtest.togy.com.cn/oyjj/langGuo/http0.png',
				'https://imgtest.togy.com.cn/oyjj/langGuo/http1.png',
				'https://imgtest.togy.com.cn/oyjj/langGuo/http4.png'
			],
			banner_index: 0,
			timer: null
		};
	},
	created() {
		this.play();
		this.$get({
			url: '/app/getBanner',
			success: res => {
				this.banner_list = res.list;
			}
		});
	},
	methods: {
		play() {
			this.timer && this.stop();
			this.timer = setInterval(() => {
				this.banner_index = this.banner_index == this.banner_list.length - 1 ? 0 : this.banner_index + 1;
			}, 5000);
		},
		stop() {
			clearInterval(this.timer);
			this.timer = null;
		},
		// 向下翻一页
		nextPage() {
			this.scroll({ scroll: document.documentElement.clientHeight }); // ==> 可见区域高度
		}
	}
};
</script>

<style scoped="scoped">
/* banner图 */
.banner-item {
	width: 100%;
	height: 100%;
	opacity: 0;
	position: absolute;
	top: 0;
	left: 0;
	transition: all 1s;
	background-position: 70% 50%;
	background-size: cover;
	background-repeat: no-repeat;
}
.banner-img {
	width: 100%;
	height: 9.47rem;
	display: block;
}
.current-banner {
	opacity: 1;
	z-index: 10;
}

/* banner图里的中英文标题 */
.banner-content {
	position: absolute;
	top: 45%;
	opacity: 0;
}
.current-banner-content {
	animation: down 0.5s;
	animation-fill-mode: forwards;
	animation-delay: 0.5s;
}
@keyframes down {
	from {
		top: 35%;
		opacity: 0;
	}
	to {
		top: 45%;
		opacity: 1;
	}
}
.banner-title {
	font-weight: 600;
	/* font-style: italic; */
	color: #ffffff;
}
/* 轮播图标点 */
/* 修改为左对齐 */
.point-box {
	position: absolute;
	bottom: 2.8rem;
	display: flex;
	overflow: hidden;
	z-index: 11;
}
.banner-point {
	width: 1rem;
	height: 0.06rem;
	/* border: 1px solid #ffffff; */
	box-sizing: border-box;
	background-color: rgba(255,255,255,.5);
}

.move-point {
	background-color: #ffffff;
	height: 100%;
	width: 0;
	transition-timing-function: linear;
}
/* 滑动按钮 */
.slid-down-box {
	position: absolute;
	left: 50%;
	transform: translateX(-50%);
	bottom: 0.4rem;
	font-size: 12px;
	color: #ffffff;
	line-height: 24px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	z-index: 11;
}
.slid-down {
	position: relative;
	width: 20px;
	height: 30px;
	border-radius: 5px;
	border: 1px solid #fff;
	box-sizing: border-box;
}
.slid-down::before {
	content: '';
	display: block;
	position: absolute;
	width: 1px;
	height: 15px;
	top: -10px;
	left: 50%;
	transform: translateX(-50%);
	background-color: #ffffff;
}
.slid-down::after {
	animation: sliddown 1.5s;
	animation-iteration-count: infinite;
	animation-timing-function: ease-in-out;
	content: '';
	display: block;
	position: absolute;
	border-radius: 50%;
	left: 50%;
	transform: translateX(-50%);
	width: 6px;
	height: 6px;
	background-color: rgba(255, 255, 255, 0);
}
@keyframes sliddown {
	0% {
		top: 4px;
	}
	40% {
		background-color: rgba(255, 255, 255, 0.9);
		top: 13px;
	}
	100% {
		top: 22px;
	}
}
</style>



// WEBPACK FOOTER //
// src/views/HomePage.vue